// material ui components
import { Button, Container, Stack, TextField, Grid, Link } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Link from "@mui/material/Link";
import {
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@mui/icons-material";

//  react module
import { useState } from "react";
// react router module
import { useHistory } from "react-router-dom";
// exported modules from other files
import User from "../../User";
import dokodemo_logo from "../../logo-dokodemo.png";
//  form modules
import * as yup from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// フォームの型
interface LoginFormInputType {
  email: string;
  name: string;
  password: string;
}

// バリデーションルール
const LoginSchema = yup.object({
  name: yup
    .string()
    .required("必須項目です")
    .max(50, "50文字以内で入力してください。"),
  email: yup
    .string()
    .required("必須項目です")
    .email("正しいメールアドレス形式で入力してください")
    .max(50, "50文字以内で入力してください。"),
  password: yup
    .string()
    .required("必須項目です")
    .min(8, "8文字以上入力してください")
    .max(30, "30文字以下で入力してください")
    .matches(/[a-zA-Z]/, "英字を含めてください")
    .matches(/[0-9]/, "数字を含めてください")
    .matches(/^[\x20-\x7e]*$/, "半角文字で入力してください。"),
});

function App() {
  // ログイン情報がローカルストレージに入っているか確認。
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || "{}");
  console.log("jsonlist:", jsonlist);

  const getState = (state: any, name: string): string =>
    (state as any)?.[name] ?? "";
  const history = useHistory();
  const err = getState(history.location.state, "err");
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormInputType>({
    resolver: yupResolver(LoginSchema),
  });

  // フォーム送信時の処理
  const onSubmit: SubmitHandler<LoginFormInputType> = (data) => {
    //ログイン時に一度ログアウトしておく
    if (!isObjEmpty(jsonlist)) {
      //console.log('データあり')
      User.logout();
    }
    // バリデーションチェックOK！なときに行う処理を追加
    //console.log(data)
    User.login("sss", "sss");
    //history.push('/Constructionlist');
    history.push({
      pathname: "/loginCheck",
      state: {
        name: data.name,
        email: data.email,
        pass: data.password,
      },
    });
  };

  function isObjEmpty(obj: any) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }

    return true;
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  //localStorage.removeItem("datalist");

  return (
    <Container maxWidth="sm" sx={{ pt: 5 }}>
      <Stack spacing={3} margin={5}>
        <img src={dokodemo_logo} alt="Logo" />
        {!!err ? (
          <Box border={2} color="red">
            <h4 style={{ color: "red", textAlign: "center" }}>{err}</h4>
          </Box>
        ) : (
          <></>
        )}
        <TextField
          required
          label="企業ID"
          autoComplete="off"
          {...register("name")}
          error={"name" in errors}
          // type email → type text
          type="text"
          helperText={errors.name?.message}
          defaultValue={('company' in jsonlist) ? ('company_id' in jsonlist.company) ? jsonlist.company.company_id : '' : ''}
          inputProps={{ maxLength: 20 }}
        />
        <TextField
          required
          label="メールアドレス"
          type="email"
          {...register("email")}
          error={"email" in errors}
          helperText={errors.email?.message}
          defaultValue={('user' in jsonlist) ? ('user_id' in jsonlist.user) ? jsonlist.user.user_id : '' : ''}
          inputProps={{ maxLength: 30 }}
        />
        <FormControl variant="outlined" color="primary">
          <InputLabel htmlFor="password" required error={"password" in errors}>
            パスワード
          </InputLabel>
          <OutlinedInput
            required
            color="primary"
            id="password"
            type={showPassword ? "text" : "password"}
            error={"password" in errors}
            inputProps={{ maxLength: 30 }}
            autoComplete="off"
            {...register("password")}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            label="パスワード"
          />
          <FormHelperText error id="password-error">
            {errors.password?.message}
          </FormHelperText>
        </FormControl>
        <Button
          style={{
            color: "#fff",
            backgroundColor: "#1565c0",
            padding: "8px 22px",
            border: 0,
            borderRadius: "4px",
          }}
          color="primary"
          name="login"
          variant="contained"
          size="large"
          onClick={handleSubmit(onSubmit)}
        >
          ログイン
        </Button>
        <Grid container>
          <Grid item xs>
            <Link href="/SendResetCode" variant="body2">
              パスワードをお忘れの方はこちら
            </Link>
          </Grid>
        </Grid>
      </Stack>
    </Container>
  );
}

export default App;
